module.exports = __webpack_public_path__ + "img/to_dial.79c68676.png";